export const SET_DADOS = 'REMESSAS/SET_DADOS'